import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { userReportRequest, userReportSuccess, userReportFailure } from '../reducers/userReport';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/getReportForContent`;

function* userReportAxios() {
  const state = yield select(fullState => fullState);
  const contentId = state.userProgramsFullReducer.selectedContentId;
  const { token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}?contentId=${contentId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerUserReportSaga() {
  try {
    const response = yield call(userReportAxios);
    const responseFromUserReport = response.data;

    yield put(userReportSuccess(responseFromUserReport));
    if (response.status === 500) {
      yield put(userReportFailure(response.statusText));
    }
  } catch (error) {
    yield put(userReportFailure(error));
  }
}

export function* watcherUserReportSaga() {
  yield takeLatest(userReportRequest().type, workerUserReportSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_userReport.js